import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {OrganizationsAlertsService} from "../../services/organizations-alerts.service";
import {OrganizationsDialogService} from "../../services/organizations-dialogs-service.factory";
import {OrganizationsRequestsService} from "../../services/organizations-requests.factory";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class OrganizationsListViewCtrl implements IController {

  organizations: any;

  public loading: boolean = false;

  constructor(private organizationsRequestsService: OrganizationsRequestsService, private organizationsDialogService: OrganizationsDialogService,
              private $log, private organizationsAlertsService: OrganizationsAlertsService, private confirmDialogService: ConfirmDialogService) {
  }

  $onInit() {
    if (!this.organizations) {
      this.organizations = [];
    }
  }

  onCreateOrganization(event) {
    this.organizationsDialogService.createOrganization(event)
      .then((newOrganization) => {
        this.loading = true;
        return this.organizationsRequestsService.createOrganization(newOrganization);
      })
      .then((createdOrganization) => {
        this.organizations.push(createdOrganization);
        this.organizationsAlertsService.createSuccess();
      })
      .catch((error) => {
        if (error) {
          this.organizationsAlertsService.createError();
          this.$log.error('Failed to create organization @organizationsListView@onCreateOrganization', error)
        } else {
          this.$log.info('Dialog Closed')
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onDeleteOrganization(organization) {
    const title = 'Delete Organization';
    const confirmText1 = 'Deleting "{{name}}" will remove the organization permanently.';
    const confirmText2 = 'Confirm deletion by typing the organization ID below: {{id}}.';
    const placeholder = 'Enter organization ID';
    const regex = organization.id;
    this.confirmDialogService.confirmEntity(title, confirmText1, confirmText2, placeholder, organization, regex)
      .then(() => {
        this.loading = true;
        return this.organizationsRequestsService.deleteOrganization(organization.id);
      })
      .then((deletedOrganization) => {
        this.organizations = _.filter(this.organizations, function (o) {
          return o.id !== deletedOrganization.id;
        });
        this.organizationsAlertsService.deleteSuccess(deletedOrganization);
      })
      .catch((error) => {
        if (error) {
          this.organizationsAlertsService.deleteError();
          this.$log.error('Failed to delete organization', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

}

angular
  .module('bringoz.admin.organizations')
  .component('organizationsListView', {
    bindings: {
      organizations: '<'
    },
    template: require('./organizations-list-view.html').default,
    controller: OrganizationsListViewCtrl
  });
